import { Box, Button } from '@zillow/constellation-10';
import { TourWizardSteps } from '../../../../constants/TourCalendar';

type TourAvailabilityCalendarFooterProps = {
  isNextDisabled: boolean;
  onClickBack: () => void;
  onClickNext: () => void;
  step: TourWizardSteps;
  hasEnabledTouring: boolean;
};

const TourAvailabilityCalendarFooter = ({
  isNextDisabled,
  onClickBack,
  onClickNext,
  step,
  hasEnabledTouring,
}: TourAvailabilityCalendarFooterProps) => {
  const isCalendarStep = step === TourWizardSteps.CALENDAR;
  const hasBackButton = (isCalendarStep || step === TourWizardSteps.TIME_ZONE) && !hasEnabledTouring;

  return (
    <Box
      css={{
        display: 'flex',
        justifyContent: hasBackButton ? 'space-between' : 'flex-end',
        margin: { base: 0, lg: '8px 48px' },
        gap: 'md',
        width: '100%',
      }}
    >
      {hasBackButton && (
        <Button
          fluid={{ base: true, lg: false }}
          emphasis="outlined"
          onClick={onClickBack}
          data-testid="TourCalendarFooter-BackBtn"
        >
          Back
        </Button>
      )}
      <Button
        fluid={{ base: true, lg: false }}
        emphasis="filled"
        disabled={isNextDisabled}
        onClick={onClickNext}
        data-testid="TourCalendarFooter-NextBtn"
      >
        {isCalendarStep ? 'Close' : 'Next'}
      </Button>
    </Box>
  );
};

export default TourAvailabilityCalendarFooter;
